import styled from "@emotion/styled";
import { BaseCell } from "src/components/Table/Cells/shared";
import Tooltip from "src/components/Tooltip";
import Monogram from "src/components/Monogram";
import { PRIMARY_BLACK } from "src/constants/colors";

const CellContainer = styled(BaseCell)<{ wide: boolean }>`
  flex: ${({ wide }) => (wide ? 2 : 1)};
  min-width: 0;
`;

const PaddedMonogram = styled(Monogram)`
  margin-right: 17px;
`;

const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
`;

const NameText = styled.div<{ preserveCase?: boolean }>`
  color: ${PRIMARY_BLACK};
  font-size: 16px;
  font-weight: 500;
  text-transform: ${({ preserveCase }) =>
    preserveCase ? "none" : "capitalize"};
  line-height: normal;
`;

const EmailText = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 12px;
`;

const NameHighlight = styled.div`
  background-color: rgba(255, 232, 26, 1);
  border: 1px solid rgba(253, 240, 124, 1);
  border-radius: 4px;
  display: inline-block;
`;

interface NameCellProps {
  firstName: string;
  lastName?: string;
  email: string;
  wide?: boolean;
  searchSelection?: string | null;
  preserveCase?: boolean;
}

export const NameCell: React.FC<NameCellProps> = ({
  searchSelection,
  firstName,
  lastName,
  email,
  wide = true,
  preserveCase = false,
}) => {
  const formatName = (name: string) =>
    preserveCase ? name : name.toLowerCase();

  const fullName = !lastName
    ? formatName(firstName)
    : `${formatName(firstName)} ${formatName(lastName)}`;
  const nameMaxLength = 20;
  const isLong = fullName.length > nameMaxLength;

  return (
    <CellContainer wide={wide}>
      <PaddedMonogram size={24}>{firstName[0]}</PaddedMonogram>
      <InfoBlock>
        <NameText preserveCase={preserveCase}>
          <Tooltip tooltipContent={fullName} disableTooltip={!isLong}>
            {searchSelection === "first_name" ? (
              <NameHighlight>{formatName(firstName)}</NameHighlight>
            ) : (
              formatName(firstName)
            )}{" "}
            {lastName &&
              (searchSelection === "last_name" ? (
                <NameHighlight>{formatName(lastName)}</NameHighlight>
              ) : (
                formatName(lastName)
              ))}
          </Tooltip>
        </NameText>
        <EmailText>{email}</EmailText>
      </InfoBlock>
    </CellContainer>
  );
};
